/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getCatalogConfigDocumentation } from '../fn/api-documentation-public/get-catalog-config-documentation';
import { GetCatalogConfigDocumentation$Params } from '../fn/api-documentation-public/get-catalog-config-documentation';
import { getContactSoftDeleteDocumentation } from '../fn/api-documentation-public/get-contact-soft-delete-documentation';
import { GetContactSoftDeleteDocumentation$Params } from '../fn/api-documentation-public/get-contact-soft-delete-documentation';
import { getContactSyncUpdateDocumentation } from '../fn/api-documentation-public/get-contact-sync-update-documentation';
import { GetContactSyncUpdateDocumentation$Params } from '../fn/api-documentation-public/get-contact-sync-update-documentation';
import { getInboundApiDocumentation } from '../fn/api-documentation-public/get-inbound-api-documentation';
import { GetInboundApiDocumentation$Params } from '../fn/api-documentation-public/get-inbound-api-documentation';
import { getInboundContactsEventsDocumentation } from '../fn/api-documentation-public/get-inbound-contacts-events-documentation';
import { GetInboundContactsEventsDocumentation$Params } from '../fn/api-documentation-public/get-inbound-contacts-events-documentation';
import { getInboundEventsDocumentation } from '../fn/api-documentation-public/get-inbound-events-documentation';
import { GetInboundEventsDocumentation$Params } from '../fn/api-documentation-public/get-inbound-events-documentation';


/**
 * Public API documentation endpoints
 */
@Injectable({ providedIn: 'root' })
export class ApiDocumentationPublicService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getInboundEventsDocumentation()` */
  static readonly GetInboundEventsDocumentationPath = '/v1/api/ui/public/docs/inbound-events';

  /**
   * Inbound event dispatcher docs (all WABA scopes).
   *
   * HTML guide for POST /inbound/v1/api/events (CONTACT_*).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInboundEventsDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInboundEventsDocumentation$Response(params?: GetInboundEventsDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getInboundEventsDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Inbound event dispatcher docs (all WABA scopes).
   *
   * HTML guide for POST /inbound/v1/api/events (CONTACT_*).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInboundEventsDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInboundEventsDocumentation(params?: GetInboundEventsDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getInboundEventsDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getInboundContactsEventsDocumentation()` */
  static readonly GetInboundContactsEventsDocumentationPath = '/v1/api/ui/public/docs/inbound-contacts-events';

  /**
   * Get inbound CONTACT events documentation.
   *
   * HTML guide for POST /inbound/v1/api/events (and alias /contacts/events).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInboundContactsEventsDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInboundContactsEventsDocumentation$Response(params?: GetInboundContactsEventsDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getInboundContactsEventsDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get inbound CONTACT events documentation.
   *
   * HTML guide for POST /inbound/v1/api/events (and alias /contacts/events).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInboundContactsEventsDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInboundContactsEventsDocumentation(params?: GetInboundContactsEventsDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getInboundContactsEventsDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getInboundApiDocumentation()` */
  static readonly GetInboundApiDocumentationPath = '/v1/api/ui/public/docs/inbound-api';

  /**
   * Get WABA inbound API documentation.
   *
   * HTML guide for unified /inbound/v1/api/* partner APIs (envelope + headers).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInboundApiDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInboundApiDocumentation$Response(params?: GetInboundApiDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getInboundApiDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get WABA inbound API documentation.
   *
   * HTML guide for unified /inbound/v1/api/* partner APIs (envelope + headers).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInboundApiDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInboundApiDocumentation(params?: GetInboundApiDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getInboundApiDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getContactSyncUpdateDocumentation()` */
  static readonly GetContactSyncUpdateDocumentationPath = '/v1/api/ui/public/docs/contact-sync-update';

  /**
   * Get Contact Sync Update API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Sync Update API including authentication, integration flow, and usage examples.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactSyncUpdateDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSyncUpdateDocumentation$Response(params?: GetContactSyncUpdateDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getContactSyncUpdateDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Contact Sync Update API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Sync Update API including authentication, integration flow, and usage examples.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactSyncUpdateDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSyncUpdateDocumentation(params?: GetContactSyncUpdateDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getContactSyncUpdateDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getContactSoftDeleteDocumentation()` */
  static readonly GetContactSoftDeleteDocumentationPath = '/v1/api/ui/public/docs/contact-delete';

  /**
   * Get Contact Delete API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Delete API including authentication, batch deletion by phone number, and usage examples.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getContactSoftDeleteDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSoftDeleteDocumentation$Response(params?: GetContactSoftDeleteDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getContactSoftDeleteDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Contact Delete API Documentation.
   *
   * Returns comprehensive HTML documentation for the Contact Delete API including authentication, batch deletion by phone number, and usage examples.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getContactSoftDeleteDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getContactSoftDeleteDocumentation(params?: GetContactSoftDeleteDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getContactSoftDeleteDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getCatalogConfigDocumentation()` */
  static readonly GetCatalogConfigDocumentationPath = '/v1/api/ui/public/docs/catalog-config';

  /**
   * Get Catalog Config Public API Documentation.
   *
   * Returns HTML documentation for GET /v1/api/ui/public/company/catalog-config/{conversationRef}, including enrichment rules for TEXT_CHOICES and CONTACT_ATTRIBUTE fields.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCatalogConfigDocumentation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCatalogConfigDocumentation$Response(params?: GetCatalogConfigDocumentation$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return getCatalogConfigDocumentation(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Catalog Config Public API Documentation.
   *
   * Returns HTML documentation for GET /v1/api/ui/public/company/catalog-config/{conversationRef}, including enrichment rules for TEXT_CHOICES and CONTACT_ATTRIBUTE fields.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCatalogConfigDocumentation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCatalogConfigDocumentation(params?: GetCatalogConfigDocumentation$Params, context?: HttpContext): Observable<any> {
    return this.getCatalogConfigDocumentation$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
